export { default } from './es/icons/CalendarOutlined';